import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './marquee.css';
import logo from '../../assets/ClaroVideoSVG.svg';
import Device from "../../devices/device";
import { ClearTextSearch } from '../../components/PersistentMiniEpg/MiniObserver';
import logger from 'src/utils/logger/logger';

class Marquee extends Component {
  constructor() {
    super();
    this.handleBackKey = this.handleBackKey.bind(this);
    this.keys = Device.getDevice().getKeys();
    this.logo = null;
    this.wrapperW = 1280;
    this.wrappweH = 720;
    this.speed = 2;
    this.x = 1;
    this.y = 1;
    this.interval = null;
  }

  handleBackKey(e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    logger.debug('Listening Marquee, currentKey:',currentKey);
    const { active } = this.props;
    switch(currentKey){
      case "BACK":
        const isActiveSearch = document.getElementsByClassName('search');
        if (isActiveSearch && isActiveSearch[1] !== undefined) {
          ClearTextSearch.fire();
        }
        if(active){
          e.preventDefault();
          e.stopPropagation();
        }
        break;
      default:
        break;
    }
  }

  componentDidMount(){
    document.addEventListener('keydown', this.handleBackKey, true);
  }

  componentWillUnmount(){
    document.removeEventListener('keydown', this.handleBackKey, true);
  }

  componentDidUpdate() {
    const { active } = this.props;
    if (active) {
      this.logo = document.getElementById('img-marquee');
      this.screensaver();
    } else {
      clearInterval(this.interval);
    }
  }

  screensaver = () => {
    let posX = this.logo.offsetLeft;
    let posY = this.logo.offsetTop;

    if (posX + this.logo.offsetWidth > this.wrapperW || posX < 0) {
      this.x *= -1;
    }

    if (posY + this.logo.offsetHeight > this.wrappweH || posY < 0) {
      this.y *= -1;
    }

    this.logo.style.left = posX + this.speed * this.x + 'px';
    this.logo.style.top = posY + this.speed * this.y + 'px';

    this.interval = setTimeout(this.screensaver, 12);
  };

  render() {
    const { active } = this.props;
    return (
      <div className="marquee">
        {active && (
          <div className="marquee-content">
            <div id="img-marquee" className="img-marquee">
              <img src={logo} alt="" className="logo" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

Marquee.propTypes = {
  active: PropTypes.bool
};

Marquee.defaultProps = {
  active: false
};

export default Marquee;



// WEBPACK FOOTER //
// ./src/components/Marquee/index.jsx